'use strict';

const Analytics = require('./analytics');

class CartInteraction extends Analytics {
    cartInteractionProduct (rawProduct, listType) {
        let productBaseInfo = this.helper.getProductBaseInfo(rawProduct);
        let productGender = this.helper.getProductGender(rawProduct);

        if (productBaseInfo.size === '') {
            productBaseInfo.size = this.size;
        }
        let promo = productBaseInfo.promo;
        if (rawProduct.price && rawProduct.price.discountValue) {
            promo = (promo && promo !== 'no_promotion') ? promo + ',sale' : 'sale';
        }
        let productSustainability = this.helper.getProductSustainability(rawProduct);
        let listingDetails = this.getItemListDetails(rawProduct);
        let product = {
            item_id: productBaseInfo.id,
            item_name: this.helper.formatString(rawProduct.nameEng),
            price: rawProduct.price.sales.value,
            quantity: '',
            index: rawProduct.GTMIndex,
            item_brand: this.helperData.brand,
            item_category: rawProduct.categoryPath,
            item_variant: productBaseInfo.color,
            size: productBaseInfo.size,
            item_on_sale: rawProduct.price.list ? 'Yes' : 'No',
            item_availability: rawProduct.availability.lowStockItems ? 'low_in_stock' : (rawProduct.available ? 'Available' : 'No'),
            coupon: promo || 'no_promotion',
            item_color: rawProduct.colorFamilyEng ? rawProduct.colorFamilyEng : '',
            item_sfcc: rawProduct.id,
            item_category2: productGender,
            item_category3: rawProduct.secondLevelCategory,
            item_category4: rawProduct.thirdLevelCategory,
            item_category5: rawProduct.fourthLevelCategory,
            item_list_name: listingDetails.item_list_name,
            item_list_id: listingDetails.item_list_id,
            discount: rawProduct.price.list ? (rawProduct.price.list.value - rawProduct.price.sales.value).toFixed(2) : 0.00,
            item_sustainable: productSustainability,
            visualization_type: listType,
            item_customization: rawProduct.personalizationItem ? rawProduct.personalizationItem : 'no',
            item_position_customization: rawProduct.personalizationPosition ? rawProduct.personalizationPosition : 'product_not_customized',
            item_font_customization: rawProduct.personalizationFontChosen ? rawProduct.personalizationFontChosen : 'product_not_customized',
            item_icon_customization: rawProduct.personalizationIconChosen ? rawProduct.personalizationIconChosen : 'product_not_customized',
            item_color_customization: rawProduct.personalizationColorChosen ? rawProduct.personalizationColorChosen : 'product_not_customized',
            item_text_customization: rawProduct.personalizationTextChosen ? rawProduct.personalizationTextChosen : 'product_not_customized',
            price_customization: rawProduct.personalizationCost ? rawProduct.personalizationCost : '0',
        };
        if (rawProduct.GTMParentItemId && rawProduct.GTMParentItemCategory4) {
            product.parent_item_id = rawProduct.GTMParentItemId;
            product.parent_item_category4 = rawProduct.GTMParentItemCategory4;
        }
        product.item_id = product.item_id ? product.item_id.replace('~', '/') : '';
        return this.helper.formatProductForAnalytics(product);
    }

    getItemListDetails (rawProduct) {
        let itemListName;
        let itemListId;

        let isMinicartCompletePromo = $('body').find('#completePromotionCartConfirm').length > 0;
        let isOrderAgain = $('body').find('.analytics.pageType.listing.orderAgainCarousel').length;

        if (isMinicartCompletePromo) {
            itemListName = 'complete_the_promo';
            itemListId = 'cart';
        } else if (isOrderAgain) {
            itemListName = 'buy_it_again';
            itemListId = this.helper.checkPage('cart') ? 'cart' : 'my_orders_and_returns';
        } else {
            itemListName = rawProduct.GTMItemListName === 'not_available' ? 'listing' : rawProduct.GTMItemListName;
            itemListId = rawProduct.GTMItemListId === 'not_available' ? 'pdp' : rawProduct.GTMItemListId;
        }

        return {
            item_list_name: itemListName,
            item_list_id: itemListId
        };
    }

    cartInteractionProductList (basket) {
        let products = [];
        if (basket && basket.items.length > 0) {
            for (let i = 0; i < basket.items.length; i++) {
                let item = basket.items[i];
                var product = {
                    'mc_id': item.id.split(' ')[0],
                    'mc_price': item.price.sales.value.toFixed(2),
                    'mc_quantity': item.quantity,
                    'mc_item_sfcc': item.id.replace('~', '/')
                };
                products.push(product);
            }
        }
        return products;
    }

    getGiftcardFromRaw (rawProduct) {
        let productBaseInfo = this.helper.getProductBaseInfo(rawProduct);
        let productGender = this.helper.getProductGender(rawProduct);

        let product = {
            item_id: productBaseInfo.id,
            item_name: this.helper.formatString(rawProduct.nameEng),
            price: rawProduct.priceTotal.priceValue,
            quantity: rawProduct.quantity,
            item_brand: this.helperData.brand,
            item_category: 'giftcard',
            item_variant: '',
            size: '',
            item_on_sale: rawProduct.price.list ? 'Yes' : 'No',
            item_availability: rawProduct.available ? 'Available' : 'No',
            coupon: 'promo' in productBaseInfo && productBaseInfo.promo ? productBaseInfo.promo : 'no_promotion',
            item_color: '',
            item_sfcc: rawProduct.id,
            item_category2: productGender,
            discount: rawProduct.price.list ? (rawProduct.price.list.value - rawProduct.price.sales.value).toFixed(2) : 0.00,
            visualization_type: 'standard'
        };

        return this.helper.formatProductForAnalytics(product);
    }

    getAddType ($container) {
        if ($container.hasClass('product-quickview')) {
            if ($container.find('.update-cart-product-global').length > 0) {
                return 'change_on_cart';
            } else if ($container.hasClass('analytics-complete-the-promo')) {
                return 'promo';
            } else {
                return 'quick_view';
            }
        } else if ($container.hasClass('product-detail')) {
            return 'product';
        } else if ($container.parent().hasClass('analytics-wishlist-card-container')) {
            return 'wishlist';
        } else if ($container.closest('#promoSlider').length > 0) {
            return 'promo';
        }

        return 'quick_view';
    }

    getList () {
        var list = $('.product-quickview .analytics.productListingItem').attr('data-item_list_name');
        if (list !== undefined && list !== '') {
            return list;
        } else if (localStorage.getItem('listtype') !== '') {
            return localStorage.getItem('listtype');
        } else {
            return 'listing';
        }
    }

    getRemoveType ($container) {
        if ($container) {
            if ($container.find('.remove-all-products-button').length > 0) {
                $('body').trigger('removedAllItemsFromCart');
                return 'empty_cart';
            } else if ($container.find('#cart_preview').length > 0) {
                return 'cart_preview';
            }
        }

        return 'cart';
    }

    init (globalContainer, helperContainer) {
        this.logName = 'CartInteraction';
        super.init(globalContainer, helperContainer);

        this.oldCart = null;
        this.toRemoveQuantity = null;

        this.prepareObservers();
        this.prepareOrderAgainObservers();
    }

    pushAddToCartInteraction (data, $container) {
        let rawProduct;
        if ($container === 'bonus_product') {
            rawProduct = data.bonusProduct;
        } else {
            rawProduct = data.cart.items.filter(function (item) {
                return item.UUID === data.pliUUID;
            })[0];
        }

        // Populate personalized data when are available
        if (data.form && data.form.personalizedObj) {
            let textTyped = data.form.personalizationText.split('<')[0];
            let iconChosen = data.form.personalizationText.split('alt=')[1];
            iconChosen = iconChosen.slice(1, iconChosen.indexOf('>') - 1);

            rawProduct['personalizationItem'] = data.form.personalizedObj ? 'customized' : 'no';
            rawProduct['personalizationPosition'] = data.form.personalizationPositionKey.toLowerCase();
            rawProduct['personalizationFontChosen'] = data.form.personalizationTextFont;
            rawProduct['personalizationIconChosen'] = iconChosen;
            rawProduct['personalizationColorChosen'] = data.form.personalizationTextColor.split('-')[0].trim();
            rawProduct['personalizationTextChosen'] = textTyped;
            rawProduct['personalizationCost'] = data.form.personalizarionCost.replace('+', '');
        }
        let listType = data.listingType ? data.listingType : 'standard';
        if (data.$analyticsContainer && data.$analyticsContainer.item_id) {
            if (localStorage.getItem('visualizationTypeProduct' + data.$analyticsContainer.item_id)) {
                listType = localStorage.getItem('visualizationTypeProduct' + data.$analyticsContainer.item_id);
            }
        }

        let product = this.cartInteractionProduct(rawProduct, listType);

        product.quantity = parseInt(data.form.quantity);
        product.index = parseInt(rawProduct.GTMIndex);

        // TODO: FIX THIS
        // let availableListTypes = this.helper.getAvailableListTypes();

        let type;
        if ($container === 'bonus_product') {
            type = 'quickview';
            product.discount = product.price;
            product.price = '0.00';
        } else {
            type = this.getAddType($container);
        }

        this.log('Pushing Add to Cart impression for: ' + product.item_id, true);

        let pushObject = {
            'event': 'add_to_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'add_type': (data.form && data.form.personalizedObj) ? 'customization' : type,
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': product.item_list_name,
                'item_list_id': product.item_list_id,
                'items': [ product ]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushAddToCart (data) {
        let pushObject = {
            'event': 'add_to_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'add_type': data.type,
            'ecommerce': {
                'currency': this.helperData.currency,
                'list_item_name': data.item_list_name,
                'list_item_id': data.item_list_id,
                'items': data.items.map((item) => {
                    return item;
                })
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushAddAllToCartWishlistInteraction (data) {
        let _self = this;
        let products = [];
        for (let i in data.allAddToCartItems) {
            delete data.allAddToCartItems[i].list;
            delete data.allAddToCartItems[i].index;
            data.allAddToCartItems[i].quantity = 1;
            if (localStorage.getItem('visualizationTypeProduct' + data.allAddToCartItems[i].item_id)) data.allAddToCartItems[i].visualization_type = localStorage.getItem('visualizationTypeProduct' + data.allAddToCartItems[i].item_id);
            let product = _self.helper.formatProductForAnalytics(data.allAddToCartItems[i]);
            product.size = _self.helper.getSkuComponents(product.item_sfcc).size;
            products.push(product);
        }
        let pushObject = {
            'event': 'addToCart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'add_type': 'wishlist',
            'ecommerce': {
                'currencyCode': this.helperData.currency,
                'add': {
                    'actionField': {'list': 'wishlist'},
                    'products': products
                }
            }
        };

        this.push(pushObject);
    }

    pushAddToCartGiftCardInteraction (data) {
        let rawProduct = null;
        rawProduct = data.cart.items.filter(function (item) {
            return item.UUID === data.pliUUID;
        })[0];

        let product = this.getGiftcardFromRaw(rawProduct);

        this.log('Pushing Add to Cart impression for giftCard');

        let pushObject = {
            'event': 'addToCart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'add_type': 'product',
            'ecommerce': {
                'currencyCode': this.helperData.currency,
                'add': {
                    'actionField': {'list': 'listing'},
                    'products': [ product ]
                }
            }
        };

        this.push(pushObject);
    }

    pushRemoveFromCartInteraction (data, $container) {
        let product = this.cartInteractionProduct(data.product);
        product.quantity = this.toRemoveQuantity;

        this.log('Pushing Remove from Cart impression for: ' + product.item_id, true);

        let pushObject = {
            'event': 'remove_from_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'remove_type': this.getRemoveType($container),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': product.item_list_name,
                'item_list_id': product.item_list_id,
                'items': [ product ]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);

        this.toRemoveQuantity = null;
        if (parseInt($('.minicart-quantity').text().trim()) === 1) {
            location.reload();
        }
    }

    updateCartAbandoned (data) {
        let products = this.cartInteractionProductList(data);
        this.log('Pushing Update Abandoned Cart impression');

        let pushObject = {
            'event': 'MCupdateCart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'cart': {
                'products': products
            }
        };

        this.push(pushObject);
    }

    pushRemoveFromCartData (data, $container) {
        const product = this.helper.formatProductForAnalytics(data.outerDiv.data());
        delete product.item_smart_gift;

        if (localStorage.getItem('visualizationTypeProduct' + data.outerDiv.data('id'))) product.visualization_type = localStorage.getItem('visualizationTypeProduct' + data.outerDiv.data('id'));
        product.quantity = 1;

        this.log('Pushing Remove from Cart impression for: ' + product.item_id, true);

        let pushObject = {
            'event': 'remove_from_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'remove_type': this.getRemoveType($container),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': product.item_list_name,
                'item_list_id': product.item_list_id,
                'items': [ product ]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    retrieveProductInfoAndRemoveFromCart (pageData) {
        this.toRemoveQuantity = ($('.product-info').data('pid').indexOf('EGC0003') > -1) ? 1 : $('.product-info.uuid-' + pageData.params.uuid.trim() + ' .checkout-product').data().quantity;
        this.size = ($('.product-info').data('pid').indexOf('EGC0003') > -1) ? 'TU' : $('.product-info.uuid-' + pageData.params.uuid.trim() + ' .checkout-product').data().size;
        let div = pageData.outerDiv;
        let id = div.data('item_id');
        let color = div.data('item_variant');

        let _self = this;
        let sku = id + '_color_' + color;
        let url = this.helperData.varianturl.replace('PID_PLACEHOLDER', encodeURIComponent(sku));
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {
                pid: sku
            },
            success: function (data) {
                data.product.available = pageData.params.available;
                _self.pushRemoveFromCartInteraction(data, data.$productContainer);
            },
            error: function (err) {
                _self.log('Cannot retrieve product information' + err);
            }
        });
    }

    pushAddToCartInteractionQuantity (data) {
        var rawProduct = data.cartModel.items.filter(function (item) {
            return item.UUID === data.form.uuid;
        })[0];
        let previousProd = this.helper.formatString(data.$productContainer.attr('data-pid'));
        let modifiedProd = this.helper.formatString(data.newProductId);
        let preQuantity = $('.js-quantity').attr('preval');
        let visualization = localStorage.getItem('visualizationTypeProduct' + data.$productContainer.attr('data-pid').split('_')[0]) || 'standard';
        let product = this.cartInteractionProduct(rawProduct, visualization);
        var quantity = data.form.quantity - preQuantity;
        product.quantity = previousProd === modifiedProd ? quantity : data.form.quantity;
        product.index = parseInt(rawProduct.GTMIndex);
        let pushObject = {
            'event': 'add_to_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'add_type': 'change_on_cart',
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': product.item_list_name,
                'item_list_id': product.item_list_id,
                'items': [ product ]
            }
        };
        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushUserRemovedAllItems () {
        this.push({
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '42',
            'eventname': 'empty_cart'
        });
    }

    prepareObservers () {
        var _self = this;

        $('body').on('product:afterAddToCart', function (e, data) {
            try {
                _self.pushAddToCartInteraction(data, data.$productContainer);
                _self.updateCartAbandoned(data.cart);
            } catch (e) {
            }
        });

        $('body').on('checkoutflow:addGiftWrap', function (e, data) {
            let items = data.order.items.items.map(rawItem => {
                let visualization = localStorage.getItem('visualizationTypeProduct' + rawItem.id.split(' ')[0]) || 'standard';
                let item = _self.cartInteractionProduct(rawItem, visualization);
                item.quantity = rawItem.quantity;
                item.item_list_id = rawItem.GTMItemListId;
                item.item_list_name = rawItem.GTMItemListName;
                return item;
            });

            data.items = items;
            data.type = 'checkout';
            data.item_list_name = 'gift_wrap';
            data.item_list_id = 'checkout';

            _self.pushAddToCart(data);
        });

        $('body').on('checkoutflow:addGiftKit', function (e, data) {
            let items = data.order.items.items
                .filter(rawItem => {
                    return rawItem.GTMItemListName === 'gift_kit';
                })
                .map((rawItem, index) => {
                    let visualization = localStorage.getItem('visualizationTypeProduct' + rawItem.id.split(' ')[0]) || 'standard';
                    let item = _self.cartInteractionProduct(rawItem, visualization);
                    item.quantity = rawItem.quantity;
                    item.item_list_id = rawItem.GTMItemListId;
                    item.item_list_name = rawItem.GTMItemListName;
                    item.index = index;
                    return item;
                });

            data.items = items;
            data.type = 'checkout';
            data.item_list_name = 'gift_kit';
            data.item_list_id = 'checkout';

            _self.pushAddToCart(data);
        });

        $('body').on('product:afterAddToCartGiftCard', function (e, data) {
            try {
                _self.pushAddToCartGiftCardInteraction(data);
            } catch (e) {}
        });

        $('body').on('removedAllItemsFromCart', function (e) {
            _self.pushUserRemovedAllItems();
        });

        $('body').on('removeItemFromCartSuccessful', function (e, data) {
            _self.pushRemoveFromCartData(data, data.$productContainer);
            _self.updateCartAbandoned(data.basket);
        });

        $('body').on('cart:afterCouponApply', function (e, data) {
            let code = data.code.toUpperCase();
            if (code !== '') {
                let where = window.location.href.includes('cart') ? 'from_cart' : (window.location.href.includes('shipping') ? 'from_shipping_page' : 'from_payment_page');
                _self.quickImpressionSender.pushCartAppliedCouponCode(code, data, where);
            }
        });

        $('body').on('click', '.js-open-coupon, .js-edit-coupon', function () {
            let where = window.location.href.includes('cart') ? 'from_cart' : (window.location.href.includes('shipping') ? 'from_shipping_page' : 'from_payment_page');
            _self.quickImpressionSender.pushCartAppliedCouponCode('no_coupon_code', { action: 'view', label: 'no_coupon_code' }, where);
        });

        $('body').on('loyaltyCoupon:apply', function (e, data) {
            let where = window.location.href.includes('cart') ? 'from_cart' : (window.location.href.includes('shipping') ? 'from_shipping_page' : 'from_payment_page');
            _self.quickImpressionSender.pushCartAppliedCouponCode(data.couponCode, { isLoyalty: true, action: 'apply' }, where);
        });

        $('body').on('click', '.shipping-methods-recap', function (e, data) {
            _self.quickImpressionSender.pushShippingMethodsMoreInfo();
        });

        $('body').on('product:addQuantityFromCart', function (e, data) {
            try {
                _self.pushAddToCartInteractionQuantity(data);
                _self.updateCartAbandoned(data.cartModel);
            } catch (e) {
            }
        });

        $('body').on('product:afterAddAllToCartWishlist', function (e, data) {
            try {
                _self.pushAddAllToCartWishlistInteraction(data);
            } catch (e) {}
        });
    }

    prepareOrderAgainObservers () {
        const _self = this;

        $('.analytics-orderAgain-cart').on('click', (e) => {
            const tab = $(e.currentTarget).data('target');

            if (tab) {
                _self.quickImpressionSender.pushCartReOrder(tab === 'cart' ? 'cart' : 'buy_it_again');
            }
        });
    }
}

const obj = new CartInteraction();
module.exports = obj;
